<template lang="pug">
div
  grid-table-component(
    v-if="paginacao.processos && paginacao.processos.length"
    :headers="headers"
    :data="paginacao.processos"
    :is-paginated="true"
    :is-loading="isLoading"
    :pagination="setPagination()"
    :enable-multi-select="true"
    :selected-items-global="selecionados"
    selected-item-key="idMonitoramento"
    @table:page-changed="checkPaginationChange($event)"
    @table:items-per-page-changed="onItemsPerPageChange"
    @selection:changed="onSelectionChanged"
  )

    //- template(v-slot:expandir="{ item }")
    //-   button.btn-expandir(
    //-     v-if="item.idAreaMonitoramento"
    //-     @click="toggleExpansao(item)"
    //-     :disabled="loadingHistorico[item.idMonitoramento]"
    //-   )
    //-     i.mdi(:class="linhasExpandidas[item.idMonitoramento] ? 'mdi-chevron-down' : 'mdi-chevron-right'")
    //-     span(v-if="loadingHistorico[item.idMonitoramento]" style="margin-left: 5px") ⏳

    template(v-slot:numeroDoCAR="{ item }")
      span(v-tooltip='{ label: item.numeroDoCAR, position: "bottom", minWidth: "360px" }') 
        | {{ item.numeroDoCAR | ellipsis(6, 4) }}

    template(v-slot:copiarCodigoImovel="{ item }")
      span(v-tooltip='{ label: "Copiar", position: "bottom", minWidth: "30px" }')
        button-component.copy-button(
          label=""
          icon="mdi-content-copy"
          color="green"
          @click.native="copyClipboard(item)"
        )

    template(v-slot:numeroMonitoramento="{ item }")
      span(style='white-space: nowrap') {{ formatarNumeroMonitoramento(item) }}

    template(v-slot:municipio="{ item }")
      span {{ item.municipio || 'Não informado' }}

    template(v-slot:envioDataMonitoramentoFormatted="{ item }")
      span {{ item.envioDataMonitoramentoFormatted || 'Não informado' }}

    template(v-slot:nomeArea="{ item }")
      span {{ item.nomeArea || 'Não informado' }}

    template(v-slot:areaRecompor="{ item }")
      span {{ item.areaRecompor | decimal }}

    template(v-slot:statusMonitoramento="{ item }")
      span {{ formatarStatus(item.statusMonitoramento) || 'Não informado' }}

    template(v-slot:condicaoInscricao="{ item }")
        span {{ getCondicaoInscricaoLabel(item.condicaoInscricao) }}

    template(v-slot:acoes="{ item }")
      .actions-check
        dropdown-component(
          :list="montarAcoes(item)"
          @input="acao => !acao.disabled && onAction(acao, item)"
          :props="{ label: 'nome', disabled: 'disabled' }"
          :is-select="false"
          position="left"
        )
          template(v-slot:item="{ item }")
            span.dropdown-option(:class="{ 'dropdown-disabled': item.disabled }")
              | {{ item.nome }}

    template(v-slot:situacao="{ item }")
        td.text-center(v-if="item.ultimoMonitoramento")
            i.fas(
                :class="getSituacaoValidacaoMonitoramentoIcon(item.statusValidacao)"
                @click="onSituacaoClick(item)"
                :title="getSituacaoValidacaoMonitoramentoTitle(item.statusValidacao)"
            )
        td.text-center(v-else-if="item.statusMonitoramento === 'FINALIZADO'")
            i.fas.fa-paper-plane.icon-enviado(
                title="Enviado"
            )
        td.text-center(v-else)
            i.fas.fa-binoculars.icon-monitoramento(
                title="Em monitoramento"
            )

    template(v-slot:row-after="{ item, index }")
      tr.historico-row(v-if="linhasExpandidas[item.idMonitoramento]" :key="'historico-' + index")
        td.historico-cell(:colspan="headers.length + 1")
          .historico-container(v-for="(hist, idx) in getHistoricoOrdenado(item.idMonitoramento)" :key="idx")
            //- .historico-checkbox
            //-   checkbox-input-component(
            //-                     :value="{ id: String(hist.idMonitoramento), selecionado: isHistoricoSelected(hist) }"
            //-                     @input="toggleHistoricoSelection(hist)"
            //-   )
            .historico-titulo
              span {{ hist.numeroMonitoramento }}º Monitoramento
                            span.badge(
                                v-if="hist.ultimoMonitoramento"
                                :class="[getSituacaoValidacaoMonitoramentoBadge(hist.statusValidacao), { 'badge-clickable': canInteragirValidacao(hist.statusValidacao) }]"
                                :title="getSituacaoValidacaoMonitoramentoTitle(hist.statusValidacao)"
                                @click="abrirModalHistorico(hist)"
                            ) {{ getSituacaoValidacaoMonitoramentoLabel(hist.statusValidacao) }}

            
            .historico-grid
              .historico-field
                span.field-label Data fim do monitoramento
                span {{ hist.envioDataMonitoramento || '-' }}
              .historico-field
                span.field-label Área
                span {{ hist.nomeArea || '-' }}
              .historico-field
                span.field-label Área a recompor
                span {{ hist.areaRecompor | decimal }}
              .historico-field
                span.field-label Status
                span {{ formatarStatus(hist.statusMonitoramento) }}
              .historico-field
                span.field-label Avaliação
                span {{ hist.avaliacaoGeral || '-' }}
          
          .historico-vazio(v-if="!historicoCache[item.idMonitoramento] || historicoCache[item.idMonitoramento].length === 0")
            i Nenhum histórico anterior encontrado

  // 👉 Mensagem de carregamento ou nenhum dado encontrado
  div(v-else style="text-align: center; padding: 16px")
    span(v-if="isLoadingLocal") ⏳ Carregando dados do monitoramento...
    span(v-else) ⚠️ Nenhum dado encontrado.
</template>
<script>
import { listarMonitoramentoAll, buscarHistoricoAreaMonitoramento } from '@/services/monitoramento.service';
import { CondicaoInscricaoEnum } from '@/enums/processo.enum.js';

export default {
    name: 'MonitoramentoTable',
    props: {
        isLoading: Boolean,
        selecionados: {
            type: Array,
            default: () => [],
        },
        isGerenteOperacional: {
            type: Boolean,
            default: false,
        },
        isTecnico: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            isLoadingLocal: false,
            statusLabels: {
                AGUARDANDO_MONITORAMENTO: 'Aguardando Monitoramento',
                PENDENTE_DE_ENVIO: 'Pendente de Envio',
                FINALIZADO: 'Finalizado',
            },
            paginacao: {
                total: 0,
                pagina: 1,
                numeroPaginas: 0,
                quantidadePagina: 10,
                processos: [],
            },
            headers: [
                //{ text: '', field: 'expandir', maxWidth: '40px', sortable: false },
                { text: 'CAR', field: 'numeroDoCAR', maxWidth: '' },
                { text: '', field: 'copiarCodigoImovel', maxWidth: '' },
                { text: 'Município', field: 'municipio', maxWidth: '' },
                { text: 'Nº', field: 'numeroMonitoramento', maxWidth: '' },
                { text: 'Data fim do monitoramento', field: 'envioDataMonitoramento', maxWidth: '' },
                { text: 'Nome da área', field: 'nomeArea', maxWidth: '' },
                { text: 'Área a recompor (ha)', field: 'areaRecompor', maxWidth: '' },
                { text: 'Status do monitoramento', field: 'statusMonitoramento', maxWidth: '' },
                { text: 'Avaliação geral', field: 'avaliacaoGeral', maxWidth: '' },
                { text: 'Fase do processo', field: 'condicaoInscricao', maxWidth: '' },
                { text: 'Ações', field: 'acoes', sortable: false, maxWidth: '' },
                { text: 'Situação', field: 'situacao', sortable: false, maxWidth: '' },
            ],
            linhasExpandidas: {},
            historicoCache: {},
            loadingHistorico: {},
        };
    },

    mounted() {
        this.pesquisar({
            uf: 'SP',
            pagina: 1,
            quantidadePagina: 10,
        });
    },
    methods: {
        formatarStatus(status) {
            return this.statusLabels[status] || 'Status desconhecido';
        },
        formatarNumeroMonitoramento(item) {
            if (!item.numeroMonitoramento) return '-';
            if (item.totalMonitoramento) return `${item.numeroMonitoramento}/${item.totalMonitoramento}`;
            return `${item.numeroMonitoramento}º`;
        },
        onSelectionChanged({ selectedItems }) {
            this.$emit('update-selecionados', selectedItems);
        },
        checkPaginationChange({ page }) {
            this.$emit('inbox:page-change', page);
        },
        onItemsPerPageChange(itemsPerPage) {
            this.$emit('inbox:items-per-page-change', itemsPerPage);
        },
        setPagination() {
            return {
                page: this.paginacao.pagina,
                totalPages: this.paginacao.numeroPaginas,
                itemsPerPage: this.paginacao.quantidadePagina,
                totalItems: this.paginacao.total,
                order: 'ASC',
                data: this.paginacao.processos,
            };
        },
        copyClipboard(item) {
            navigator.clipboard.writeText(item.numeroDoCAR);
            this.$toast({
                showClose: true,
                message: 'Código Copiado',
                type: 'success',
            });
        },
        tooltipDescricao(acao) {
            return acao.tooltip || 'Ação desabilitada';
        },
        montarAcoes(item) {
            const acoes = [
                { nome: 'Ficha do imóvel', id: 'ficha', acao: 'fichaImovel' },
                { nome: 'Monitoramento enviado', id: 'monitoramentoEnviado', acao: 'monitoramentoEnviado' },
            ];

            if (item.faseProcesso === 'RESUMO') {
                acoes.splice(1, 0, {
                    // insere na posição 1 (entre as outras duas)
                    id: 'recibo',
                    nome: 'Recibo do monitoramento',
                    acao: 'reciboMonitoramento',
                    disabled: false,
                    tooltip: '',
                });
            }

            if (item.statusMonitoramento === 'PENDENTE_DE_ENVIO' && this.isMonitoramentoVencido(item.envioDataMonitoramento)) {
                acoes.push({
                    nome: 'Enviar Notificação',
                    id: 'enviarNotificacao',
                    acao: 'enviarNotificacao',
                });
            }

            if (this.canAcessarValidacao(item.statusValidacao)) {
                acoes.push({ nome: this.getNomeAcaoValidacao(item.statusValidacao), id: 'validar', acao: 'validar' });
            }

            return acoes;
        },
        onAction(acao, item) {
            switch (acao.id) {
                case 'ficha':
                    this.$emit('abrir-ficha', item);
                    break;
                case 'recibo':
                    this.$emit('gerar-recibo', item);
                    break;
                case 'monitoramentoEnviado':
                    this.$emit('abrir-monitoramento', item);
                    break;
                case 'enviarNotificacao':
                    this.$emit('enviar-notificacao', item);
                    break;
                case 'validar':
                    if (this.canAcessarValidacao(item.statusValidacao)) {
                        this.$emit('validar-monitoramento', item);
                    }
                    break;
            }
        },
        async pesquisar(filtro) {
            this.isLoadingLocal = true;
            this.paginacao.processos = [];

            try {
                const resposta = await listarMonitoramentoAll(filtro);

                if (resposta && Array.isArray(resposta.content)) {
                    const dadosMonitoramento = resposta.content.map((item) => ({
                        ...item,
                        etapasFotoParcela: item.etapasFotoParcela || [],
                    }));

                    this.paginacao = {
                        ...this.paginacao,
                        processos: dadosMonitoramento,
                        total: resposta.totalElements,
                        numeroPaginas: resposta.totalPages,
                        quantidadePagina: resposta.size,
                        pagina: resposta.pageable.pageNumber + 1,
                    };
                }
            } catch (error) {
                this.$message.error('Erro ao listar monitoramento');
            } finally {
                this.isLoadingLocal = false;
            }
        },
        getCondicaoInscricaoLabel(idCondicaoInscricao) {
            const condicaoInscricao = Object.values(CondicaoInscricaoEnum).find(item => item.id === idCondicaoInscricao);
            return condicaoInscricao ? condicaoInscricao.label : '-';
        },
        getSituacaoValidacaoMonitoramentoLabel(statusValidacao) {
            
            if(statusValidacao === null)
                return 'EM MONITORAMENTO';

            return statusValidacao === 'PENDENTE_VALIDACAO' ? 'PENDENTE DE VALIDAÇÃO' : statusValidacao;
        },
        getSituacaoValidacaoMonitoramentoTitle(statusValidacao) {
            
            if(statusValidacao === null)
                return this.getSituacaoValidacaoMonitoramentoLabel(statusValidacao);

            if (!this.canAcessarValidacao(statusValidacao))
                return this.getSituacaoValidacaoMonitoramentoLabel(statusValidacao);

            return statusValidacao === 'PENDENTE_VALIDACAO' ? this.getSituacaoValidacaoMonitoramentoLabel(statusValidacao) : 'Visualizar monitoramento ' + this.getSituacaoValidacaoMonitoramentoLabel(statusValidacao);
        },
        getSituacaoValidacaoMonitoramentoBadge(statusValidacao) {
            if(statusValidacao === null)
                return '';

            if(statusValidacao === 'PENDENTE_VALIDACAO')
                return 'badge-pendente';

            return statusValidacao === 'APROVADO' ? 'badge-aprovado' : 'badge-reprovado';
        },
        canInteragirValidacao(statusValidacao) {
            return this.canAcessarValidacao(statusValidacao);
        },
        canAcessarValidacao(statusValidacao) {
            return (this.isGerenteOperacional || this.isTecnico) && ['PENDENTE_VALIDACAO', 'APROVADO', 'REPROVADO'].includes(statusValidacao);
        },
        getNomeAcaoValidacao(statusValidacao) {
            return this.isGerenteOperacional && statusValidacao === 'PENDENTE_VALIDACAO' ? 'Validar monitoramento' : 'Visualizar validação';
        },
        getSituacaoValidacaoMonitoramentoIcon(statusValidacao) {
            const classes = [];

            if(statusValidacao === null)
                classes.push('fa-binoculars', 'icon-monitoramento');

            else if(statusValidacao === 'PENDENTE_VALIDACAO')
                classes.push('fa-clock', 'icon-pendente');

            else
                classes.push(statusValidacao === 'APROVADO' ? 'fa-check-circle' : 'fa-times-circle', statusValidacao === 'APROVADO' ? 'icon-aprovado' : 'icon-reprovado');

            if (this.canInteragirValidacao(statusValidacao))
                classes.push('icon-clickable');

            return classes.join(' ');

        },
        getHistoricoOrdenado(idMonitoramento) {
            const historico = this.historicoCache[idMonitoramento] || [];
            return [...historico].sort((a, b) => (b.numeroMonitoramento || 0) - (a.numeroMonitoramento || 0));
        },
        async carregarHistorico(item) {
            const itemId = item.idMonitoramento;

            this.$set(this.loadingHistorico, itemId, true);

            try {
                const historico = await buscarHistoricoAreaMonitoramento(item.idAreaMonitoramento);
                const historicoCompleto = Array.isArray(historico) ? historico : [];

                this.$set(this.historicoCache, itemId, historicoCompleto);
                this.$set(this.linhasExpandidas, itemId, true);
            } catch (error) {
                this.$message.error('Erro ao carregar histórico');
            } finally {
                this.$set(this.loadingHistorico, itemId, false);
            }
        },
        async refreshHistoricoCache(itemValidado) {
            if (!itemValidado?.idAreaMonitoramento) {
                return;
            }

            const itemPai = this.paginacao.processos.find(
                item => item.idAreaMonitoramento === itemValidado.idAreaMonitoramento
            );

            if (!itemPai) {
                return;
            }

            const itemPaiId = itemPai.idMonitoramento;
            const estavaExpandido = !!this.linhasExpandidas[itemPaiId];

            this.$delete(this.historicoCache, itemPaiId);

            if (estavaExpandido) {
                await this.carregarHistorico(itemPai);
            }
        },
        abrirModalValidacao(item) {
            if (!item || !this.canAcessarValidacao(item.statusValidacao)) {
                return;
            }

            this.$emit('validar-monitoramento', item);
        },
        onSituacaoClick(item) {
            this.abrirModalValidacao(item);
        },
        abrirModalHistorico(item) {
            if (!item || !this.canAcessarValidacao(item.statusValidacao)) {
                return;
            }

            this.abrirModalValidacao(item);
        },
        async toggleExpansao(item) {
            const itemId = item.idMonitoramento;
            
            // Se já está expandido, apenas colapse
            if (this.linhasExpandidas[itemId]) {
                this.$set(this.linhasExpandidas, itemId, false);
                return;
            }
            
            // Se não tem histórico em cache, busque
            if (!this.historicoCache[itemId]) {
                await this.carregarHistorico(item);
            } else {
                // Histórico já está em cache, apenas expanda
                this.$set(this.linhasExpandidas, itemId, true);
            }
        },

        parseDataBR(dataString) {
            if (!dataString) return null;

            const [dataParte] = dataString.split(' ');
            const [dia, mes, ano] = dataParte.split('/').map(Number);

            if (!dia || !mes || !ano) return null;

            return new Date(ano, mes - 1, dia);
        },
        isMonitoramentoVencido(envioDataMonitoramento) {
            const data = this.parseDataBR(envioDataMonitoramento);
            if (!data) return false;

            const hoje = new Date();
            hoje.setHours(0, 0, 0, 0);

            const ontem = new Date(hoje);
            ontem.setDate(ontem.getDate() - 1);

            return data < ontem;
        },
    },
};
</script>

<style scoped>
/* Base da Badge */
.badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.25rem 0.75rem;
  font-size: 0.85rem;
  font-weight: 600;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 50rem;
  border: 1px solid transparent;
  transition: all 0.2s ease-in-out; /* Suaviza a interação */

  background-color: #e0e7ff;
  color: #4338ca;
  border: 1px solid #c7d2fe;
}

/* Comportamento de Botão para Aprovado e Reprovado */
.badge-clickable {
  cursor: pointer;
  user-select: none; /* Evita selecionar o texto ao clicar rápido */
}

.badge-clickable:hover {
  filter: brightness(0.95); /* Escurece levemente a cor */
  transform: translateY(-1px); /* Pequeno pulo para cima */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.badge-clickable:active {
  transform: translateY(0); /* Volta ao normal ao clicar */
  filter: brightness(0.9);
}

/* Cores Específicas */
.badge-aprovado {
  background-color: #dcfce7;
  color: #15803d;
  border-color: #bbf7d0;
}

.badge-reprovado {
  background-color: #fee2e2;
  color: #b91c1c;
  border-color: #fecaca;
}

.badge-pendente {
  background-color: #fef3c7;
  color: #b45309;
  border-color: #fde68a;
}

.text-center i {
  font-size: 1.2rem;
  transition: transform 0.2s;
}

.icon-clickable {
  cursor: pointer;
}

.icon-clickable:hover {
  transform: scale(1.2);
}

.icon-aprovado {
  color: #2d7a47; 
}

.icon-reprovado {
  color: #c9302c; 
}

.icon-monitoramento {
  color: #0284c7; 
}

.icon-pendente {
  color: #b45309; 
}

.icon-enviado {
    color: #1f77b4;
}

.btn-expandir {
    background: none;
    border: none;
    cursor: pointer;
    padding: 4px 8px;
    display: flex;
    align-items: center;
    color: #59b52b;
    font-size: 18px;
    transition: all 0.2s;
}

.btn-expandir:hover:not(:disabled) {
    color: #45a714;
    background-color: #f0f0f0;
    border-radius: 4px;
}

.btn-expandir:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.historico-row {
    background-color: #f7f7f7 !important;
}

.historico-cell {
    padding: 0 !important;
    border: 1px solid #00000037 !important;
    background-color: #f7f7f7;
}

.historico-container {
    padding: 24px 40px;
    border-left: 4px solid #59b52b;
    margin: 16px 20px;
    background-color: white;
    border-radius: 4px;
    box-shadow: 0 1px 3px rgba(0,0,0,0.08);
    position: relative;
    display: flex;
    flex-direction: column;
}

.historico-checkbox {
    position: absolute;
    left: 8px;
    top: 24px;
    display: flex;
    align-items: center;
}

.historico-titulo {
    font-size: 13px;
    font-weight: 600;
    color: #333;
    margin-bottom: 16px;
    display: flex;
    align-items: center;
    padding-bottom: 12px;
    border-bottom: 1px solid #e0e0e0;
}

.historico-item {
    padding: 14px;
    margin-bottom: 12px;
    background-color: #fafafa;
    border: 1px solid #e8e8e8;
    border-radius: 4px;
    transition: all 0.2s;
}

.historico-item:hover {
    background-color: #f5f5f5;
    border-color: #59b52b;
    box-shadow: 0 1px 4px rgba(89, 181, 43, 0.1);
}

.historico-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    gap: 12px;
    font-size: 12px;
}

.historico-field {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.field-label {
    font-weight: 600;
    color: #666;
    font-size: 10px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.historico-field span:not(.field-label) {
    color: #333;
    font-size: 12px;
}

.historico-vazio {
    padding: 24px;
    text-align: center;
    color: #999;
    font-style: italic;
    font-size: 12px;
    background-color: #fafafa;
    border-radius: 4px;
    border: 1px dashed #ddd;
}

.copy-button {
    background-color: transparent !important;
    box-shadow: none !important;
}

.dropdown-disabled {
    color: #aaa;
    display: inline-flex;
    align-items: center;
    gap: 4px;
    pointer-events: none;
}
</style>
